import { canv } from "@/canv/global";
import type { EntityBaseState } from "@/shared/types/entityState";
import type { FixType } from "@/shared/types/fixType";
import type { PropertyEventStructure } from "./types";

export class PropertyEvent {
    event: PropertyEventStructure;

    constructor(UID: string, fixType: FixType, state: EntityBaseState) {
        this.event = {
            type: "property",
            UID,
            fixType,
            state,
        };
    }

    execEvent() {
        if (!this.event) {
            return;
        }

        const entity = canv.canvasController.FindByUID(this.event.UID);

        if (entity === null) {
            return;
        }

        //Убрать после более строгой типизации state
        //@ts-ignore
        entity.loadState(this.event.state, this.event.fixType);
    }

    checkEvent() {
        if (!this.event) {
            return;
        }

        const entity = canv.canvasController.FindByUID(this.event.UID);

        if (entity === null || entity === undefined) {
            return false;
        }

        return entity.checkEvent(this.event.state, this.event.fixType);
    }

    getEvent() {
        return this.event;
    }

    loadEvent(event: PropertyEventStructure) {
        this.event = event;
    }

    getTwin() {
        const entity = canv.canvasController.FindByUID(this.event.UID);

        const twinState = entity?.getState(this.event.fixType, this.event.state);
        const twin = new PropertyEvent(
            this.event.UID,
            this.event.fixType,
            twinState as EntityBaseState,
        );

        return twin;
    }
}
